import React from 'react'
import './about.css'
import ME from '../../assets/cavs game.JPG'
import {IoIosSchool} from 'react-icons/io'
import {FaCameraRetro} from 'react-icons/fa'
import {AiFillGithub} from 'react-icons/ai'
import {GiLaptop} from 'react-icons/gi'

const about = () => (
  <section id='about'>
    <h5>Get To Know</h5>
    <h2>About Me</h2>
    <div className="container about__container">
      <div className="about__me">
        <div className="about__me-image">
          <img src={ME} alt='AboutImage' />
        </div>
      </div>
        <div className="about__content">
          <div className="about__cards">
            <article className='about__card'>
              <IoIosSchool className="about__icon" />
              <h5>Education</h5>
              <small>Cleveland State University</small>
              <br></br>
              <small>FullStack Academy</small>
            </article>

            <article className='about__card'>
              <FaCameraRetro className="about__icon" />
              <h5>Hobbies</h5>
              <small>Coding</small><br></br>
              <small>Sports</small><br></br>
              <small>Fitness</small><br></br>
              <small>Doing things Outdoors</small><br></br>
            </article>

            <article className='about__card'>
              <GiLaptop className="about__icon" />
              <h5>Projects</h5>
              <small>Check Out My Codes</small><br></br>
              <small>On Github</small>
              <br></br>
              <a href='https://github.com/Nikoboykin' target="_blank"><AiFillGithub /></a>
            </article>
          </div>



        <p>In my free time away from learning web development I enjoy many hobbies. Firstly, basketball! I have spent my entire life playing and watching the sport. Basketball has become therapeutic for me since ive been playing so long. No matter how busy life gets Ill always make time to pick up a ball and play.

        </p>
        <a href='#contact' className='btn btn-primary'>Contact Me</a>
      </div>
    </div>
  </section>
)

export default about